import { ddeApi } from '@/service/ddeApi'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

export type LicensePropertyData = {
  property: string
  operatorCount: number
}

const fetchLicensesApiCallback = async (
  args: FetchApiArgs<unknown, string, string>
): Promise<FetchApiResponse<LicensePropertyData>> => {
  const { signal } = args

  const { data: operatorsLicenses } =
    await ddeApi.endpoints.operators.getAllLicensePropertiesWithOperators(signal)

  const licenseProperties: LicensePropertyData[] = operatorsLicenses.map(
    ({
      property,
      operators
    }: {
      property: string
      operators: Array<{ id: number; name: string }>
    }) => ({
      property,
      operatorCount: operators.length
    })
  )

  return {
    content: licenseProperties,
    totalElements: licenseProperties.length
  }
}

export const useLicensesStore = createBaseTableStore({
  storeName: 'Licenses',
  fetchApi: fetchLicensesApiCallback,
  features: {
    pagination: false,
    sorting: true,
    filtering: true
  }
})
